import React from 'react';
const SvgVstx = React.forwardRef((rest, ref) => {
  const props = { ...rest, ref };
  return (
    <svg viewBox="0 0 48 48" width="1em" height="1em" {...props}>
      <path fill="#FFF" d="M41 6V3H12v39h3v3h29V6z" />
      <path fill="#C8C8C8" d="M26 25v5h-5v-5h5m1-1h-7v7h7v-7z" />
      <path fill="#3955A3" d="M41 3H12v6h29V5l3 3V6z" />
      <path fill="#949494" d="M43 7v37H16v-2h25V9h-1v32H13V9h-1v33h3v3h29V8z" />
      <path
        fill="#C8C8C8"
        d="M33.5 32c1.378 0 2.5 1.122 2.5 2.5S34.878 37 33.5 37 31 35.878 31 34.5s1.122-2.5 2.5-2.5m0-1a3.5 3.5 0 100 7 3.5 3.5 0 000-7zM30.5 16c1.378 0 2.5 1.122 2.5 2.5S31.878 21 30.5 21 28 19.878 28 18.5s1.122-2.5 2.5-2.5m0-1a3.5 3.5 0 100 7 3.5 3.5 0 000-7zM34 27h-7v1h7v-1z"
      />
      <path
        fill="#C8C8C8"
        d="M34 28h-1v4h1v-4zM31 21h-1v7h1v-7zM16.5 12a.5.5 0 100 1 .5.5 0 000-1zM19.5 12a.5.5 0 100 1 .5.5 0 000-1zM22.5 12a.5.5 0 100 1 .5.5 0 000-1zM25.5 12a.5.5 0 100 1 .5.5 0 000-1zM28.5 12a.5.5 0 100 1 .5.5 0 000-1zM36.5 17a.5.5 0 100 1 .5.5 0 000-1zM36.5 20a.5.5 0 100 1 .5.5 0 000-1zM36.5 23a.5.5 0 100 1 .5.5 0 000-1zM36.5 26a.5.5 0 100 1 .5.5 0 000-1zM36.5 29a.5.5 0 100 1 .5.5 0 000-1zM28.5 37a.5.5 0 100 1 .5.5 0 000-1zM25.5 37a.5.5 0 100 1 .5.5 0 000-1z"
      />
      <path fill="#3955A3" d="M4 17l20-3v26L4 37z" />
      <path
        fill="#FFF"
        d="M19 21l-3.665 12H12.62L9 21h2.582l2.218 8.351c.118.452.19.851.215 1.197h.044c.035-.373.112-.783.23-1.23L16.493 21H19z"
      />
      <linearGradient id="vstx_svg__a" gradientUnits="userSpaceOnUse" x1={17.754} y1={42.918} x2={18.177} y2={38.93}>
        <stop offset={0} stopColor="#828282" stopOpacity={0} />
        <stop offset={0.17} stopColor="#7e7e7e" stopOpacity={0.034} />
        <stop offset={0.346} stopColor="#717171" stopOpacity={0.069} />
        <stop offset={0.525} stopColor="#5d5d5d" stopOpacity={0.105} />
        <stop offset={0.706} stopColor="#404040" stopOpacity={0.141} />
        <stop offset={0.886} stopColor="#1b1b1b" stopOpacity={0.178} />
        <stop offset={0.997} stopOpacity={0.2} />
      </linearGradient>
      <path fill="url(#vstx_svg__a)" d="M24 43H12v-4.8L24 40z" />
      <linearGradient id="vstx_svg__b" gradientUnits="userSpaceOnUse" x1={12.999} y1={8.22} x2={40.001} y2={42.781}>
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={0.226} stopColor="#fcfcfc" stopOpacity={0.023} />
        <stop offset={0.363} stopColor="#f4f4f4" stopOpacity={0.036} />
        <stop offset={0.475} stopColor="#e6e6e6" stopOpacity={0.048} />
        <stop offset={0.574} stopColor="#d1d1d1" stopOpacity={0.057} />
        <stop offset={0.665} stopColor="#b7b7b7" stopOpacity={0.067} />
        <stop offset={0.75} stopColor="#979797" stopOpacity={0.075} />
        <stop offset={0.83} stopColor="#707070" stopOpacity={0.083} />
        <stop offset={0.906} stopColor="#444" stopOpacity={0.091} />
        <stop offset={0.976} stopColor="#121212" stopOpacity={0.098} />
        <stop offset={1} stopOpacity={0.1} />
      </linearGradient>
      <path fill="url(#vstx_svg__b)" d="M12 9h29v33H12z" />
      <linearGradient id="vstx_svg__c" gradientUnits="userSpaceOnUse" x1={23.428} y1={18.729} x2={43.971} y2={45.022}>
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={0.226} stopColor="#fcfcfc" stopOpacity={0.023} />
        <stop offset={0.363} stopColor="#f4f4f4" stopOpacity={0.036} />
        <stop offset={0.475} stopColor="#e6e6e6" stopOpacity={0.048} />
        <stop offset={0.574} stopColor="#d1d1d1" stopOpacity={0.057} />
        <stop offset={0.665} stopColor="#b7b7b7" stopOpacity={0.067} />
        <stop offset={0.75} stopColor="#979797" stopOpacity={0.075} />
        <stop offset={0.83} stopColor="#707070" stopOpacity={0.083} />
        <stop offset={0.906} stopColor="#444" stopOpacity={0.091} />
        <stop offset={0.976} stopColor="#121212" stopOpacity={0.098} />
        <stop offset={1} stopOpacity={0.1} />
      </linearGradient>
      <path fill="url(#vstx_svg__c)" d="M41 5v37H15v3h29V8z" />
      <linearGradient id="vstx_svg__d" gradientUnits="userSpaceOnUse" x1={28} y1={44.906} x2={28} y2={42.087}>
        <stop offset={0} stopColor="#828282" stopOpacity={0} />
        <stop offset={0.281} stopColor="#7f7f7f" stopOpacity={0.028} />
        <stop offset={0.45} stopColor="#777" stopOpacity={0.045} />
        <stop offset={0.59} stopColor="#696969" stopOpacity={0.059} />
        <stop offset={0.713} stopColor="#545454" stopOpacity={0.071} />
        <stop offset={0.826} stopColor="#3a3a3a" stopOpacity={0.083} />
        <stop offset={0.929} stopColor="#1a1a1a" stopOpacity={0.093} />
        <stop offset={1} stopOpacity={0.1} />
      </linearGradient>
      <path fill="url(#vstx_svg__d)" d="M15 42h26v3H15z" />
      <linearGradient id="vstx_svg__e" gradientUnits="userSpaceOnUse" x1={27.839} y1={8.577} x2={28.166} y2={2.34}>
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={0.854} stopColor="#fff" stopOpacity={0.213} />
        <stop offset={1} stopColor="#fff" stopOpacity={0.25} />
      </linearGradient>
      <path fill="url(#vstx_svg__e)" d="M41 3H12v6h29V5l3 3V6z" />
      <linearGradient id="vstx_svg__f" gradientUnits="userSpaceOnUse" x1={14} y1={39.188} x2={14} y2={14.758}>
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={0.859} stopColor="#fff" stopOpacity={0.155} />
        <stop offset={1} stopColor="#fff" stopOpacity={0.18} />
      </linearGradient>
      <path fill="url(#vstx_svg__f)" d="M24 14L4 17v20l20 3z" />
    </svg>
  );
});
export default SvgVstx;
SvgVstx.iconName = 'vstx';
SvgVstx.displayName = 'SvgVstx';
